module.exports = __webpack_public_path__ + "static/img/22.514bcbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/22.png
// module id = F349
// module chunks = 35